module.exports = __webpack_public_path__ + "assets/img/zhu.2b8b5804.png";